import DialogContent from "@mui/material/DialogContent";
import { useMemo } from "react";

const ModalContent = ({ children, sx }) => {
  const styles = useMemo(() => {
    let sty = { p: 3 };
    return {
      ...sty,
      ...sx,
    };
  }, [sx]);
  return <DialogContent sx={styles}>{children}</DialogContent>;
};

export default ModalContent;
